import styled from "styled-components";
import { Wrapper } from 'AppReact';

export const template = styled.div`
  position: static;
`;

export default Wrapper(template);